import * as angular from "angular";
import {ILocationService, ILogService, IRootScopeService} from "angular";
import uiRouter, {StateProvider, StateService, UrlRouterProvider} from "@uirouter/angularjs";
import {AcceptCreditModalComponent} from "./accept-credit-modal/accept-credit-modal.component";
import {LoadingModule} from "../shared/loading/loading.module";
import {ApplicationModule} from "../shared/application/application.module";
import {WidgetModule} from "../shared/widget/widget.module";
import {ApplicationComponent} from "./application/application.component";
import {ApplicationSummaryComponent} from "./application-summary/application-summary.component";
import {DeclineCreditModalComponent} from "./decline-credit-modal/decline-credit-modal.component";
import {StudentDashboardComponent} from "./dashboard/student-dashboard.component";
import {StudentApplicationFooterComponent} from "./application/footer/student-application-footer.component";
import {ApplicationService} from "../shared/application/application.service";
import {CourseService} from "../shared/course/course.service";
import {Application} from "../shared/model/Application";
import {FacultyService} from "../shared/faculty/faculty.service";

export const StudentModule = angular
    .module("app.student", [
        "toaster",
        "ui.bootstrap",
        uiRouter,
        ApplicationModule,
        LoadingModule,
        WidgetModule
    ])

    .component("application", ApplicationComponent)
    .component("acceptCreditModal", AcceptCreditModalComponent)
    .component("applicationSummaryStudent", ApplicationSummaryComponent)
    .component("studentDashboard", StudentDashboardComponent)
    .component("declineCreditModal", DeclineCreditModalComponent)
    .component("applicationFooterStudent", StudentApplicationFooterComponent)

    .config(($stateProvider: StateProvider, $urlRouterProvider: UrlRouterProvider) => {
        $urlRouterProvider.when("/student", "/student/application");

        $stateProvider
            .state("student", {
                parent: "app",
                abstract: true,
                url: "/student",
                component: "layout"
            })

            .state("student.switchMode", {
                url: "/switch-mode",
                template: require("./switch-mode.html")
            })

            .state("student.application", {
                url: "/application/:applicationId",
                params: {
                    applicationId: {squash: true, value: null}
                },
                component: "application",
                resolve: {
                    application: (applicationService: ApplicationService, $stateParams) =>
                        $stateParams.applicationId ?
                            applicationService.getStudentCreditRequestById($stateParams.applicationId) :
                            null,
                    applicationHistories: () => [],

                    currentCourses: (currentUser, courseService: CourseService) => {
                        if (currentUser.callistaPersonId) {
                            return courseService.getCurrentCourses(currentUser.callistaPersonId);
                        } else {
                            return [];
                        }
                    },
                    teachingPeriods: (facultyService: FacultyService) => facultyService.getTeachingPeriods(),
                    assessments: () => [],
                    studentMode: () => true
                }
            })

            .state("student.summary", {
                url: "/summary/:applicationId",
                component: "applicationSummaryStudent",
                resolve: {
                    studentCreditRequest:  (applicationService: ApplicationService, $stateParams) =>
                        $stateParams.applicationId ?
                            applicationService.getStudentCreditRequestById($stateParams.applicationId) :
                            null,
                    applications: (applicationService: ApplicationService, studentCreditRequest: Application) =>
                        studentCreditRequest ? applicationService.getStudentCreditRequestApplications(studentCreditRequest.id) : null
                }
            })
            .state("student.dashboard", {
                url: "/dashboard",
                component: "studentDashboard",
                resolve: {
                    applications: (applicationService: ApplicationService) =>
                        applicationService.getStudentCreditRequests()
                }
            });
    })

    .run(($rootScope: IRootScopeService, $location: ILocationService, $log: ILogService, $state: StateService) => {
        $log.debug("app.student - Run - All registered routes:", $state.get());
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/student/student.module.ts